import { render, staticRenderFns } from "./MortgageRatesWidgetTab.vue?vue&type=template&id=42d97024&scoped=true"
import script from "./MortgageRatesWidgetTab.vue?vue&type=script&lang=js"
export * from "./MortgageRatesWidgetTab.vue?vue&type=script&lang=js"
import style0 from "./MortgageRatesWidgetTab.vue?vue&type=style&index=0&id=42d97024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d97024",
  null
  
)

export default component.exports